export default {
  root: {
    class: [
      // Alignment
      "flex items-center",
      "gap-2",
      "[&_[data-pc-name=pcinput]]:w-14",
      "[&_[data-pc-name=pcinput]]:h-14",
      "[&_[data-pc-name=pcinput]]:text-center",
    ],
  },
};
